export default "__VITE_ASSET__DwU1Q2QF__"